<template>
  <intersect @enter="animate = true" :threshold="[0, 0.25, 0.5, 0.75, 1]">
    <div
      class="adventages-container mt-34 fadeUp"
      v-if="_.get(imageData, 'images')"
      :class="animate ? 'animate' : ''"
    >
      <h3 class="font-21 noto-semibold">
        {{ _.get(imageData, "images_list_head") }}
      </h3>

      <section class="layout-images flex-box mt-21" v-if="imageData.images">
        <div
          class="image-container"
          v-for="(item, index) in imageData.images"
          :key="index"
        >
          <div class="img-box">
            <picture>
              <source
                media="(max-width: 767px)"
                :srcset="_.get(item, 'devices.mobile')"
              />
              <source
                media="(max-width: 1023px)"
                :srcset="_.get(item, 'devices.tablet')"
              />
              <img
                :src="_.get(item, 'devices.desktop')"
                :alt="_.get(item, 'title')"
                class="img-absolute"
              />
            </picture>

            <div class="gradient"></div>
          </div>
          
          <h4 class="img-title noto-semibold" v-if="_.get(item, 'title')">
            {{ _.get(item, "title") }}
          </h4>
        </div>
      </section>
    </div>
  </intersect>
</template>

<script>
import Intersect from "vue-intersect";
export default {
  props: {
    imageData: {
      type: Object,
    },
  },
  components: { Intersect },
  data() {
    return {
      animate: false,
    };
  },
};
</script>

<style>
.layout-images .img-box:nth-child(n + 4) {
  display: none;
}
</style>
